import React from "react";

var LsPrivacyPolicy = () => {
    return (
      <div>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width" />
        <title>Privacy Policy</title>
        <style dangerouslySetInnerHTML={{__html: " body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding:1em; } " }} />
        <strong>Privacy Policy</strong> <p>
          LinguaSyne was built as a Free app. This SERVICE is provided at no cost and is intended for use as is.
        </p> <p>
          This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.
        </p> <p>
          If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is
          used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.
        </p> <p><strong>Information Collection and Use</strong></p> <p>
          To use the Service, you will be required to share your email address in order to create an account. Account authentication is handled by Google's Firebase service
          meaning your password cannot be seen by anyone and is fully encrypted. I, the developer, am able to see your email address, and if you choose to upload a profile image 
          (not doing so does not affect functionality of the app) I will have access to view said image. No other personal data is collected, used or handled by LinguaSyne.
        </p> <div><p>
            Links to the privacy policy of third-party service providers used by the app
          </p> <ul><li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>{/**/}<li><a href="https://firebase.google.com/policies/analytics" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase</a></li>{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}{/**/}</ul></div><p>              
        </p> <p><strong>Links to Other Sites</strong></p> <p>
          This Service may contain links to other sites. If you click on
          a third-party link, you will be directed to that site. Note
          that these external sites are not operated by me.
          Therefore, I strongly advise you to review the
          Privacy Policy of these websites. I have
          no control over and assume no responsibility for the content,
          privacy policies, or practices of any third-party sites or
          services.
        </p> <p><strong>Children’s Privacy</strong></p> <div><p>
            These Services do not address anyone under the age of 13.
            I do not knowingly collect personally
            identifiable information from children under 13 years of age. In the case
            I discover that a child under 13 has provided
            me with personal information, I immediately
            delete this from our servers. If you are a parent or guardian
            and you are aware that your child has provided us with
            personal information, please contact me so that
            I will be able to do the necessary actions.
          </p></div> {/**/} <p><strong>Changes to This Privacy Policy</strong></p> <p>
          I may update our Privacy Policy from
          time to time. Thus, you are advised to review this page
          periodically for any changes. I will
          notify you of any changes by posting the new Privacy Policy on
          this page.
        </p> <p>This policy is effective as of 2023-01-09</p> <p><strong>Contact Us</strong></p> <p>
          If you have any questions or suggestions about my
          Privacy Policy, do not hesitate to contact me at daymax96@gmail.com.
        </p>
        
        <div>
        <a href="mailto:daymax96@gmail.com?subject=Delete%20my%20LinguaSyne%20account&body=I%20no%20longer%20want%20to%20have%20a%20LinguaSyne%20account%2C%20and%20request%20that%20my%20account%20and%20user%20data%20be%20deleted.">
          Click here to request account deletion.
        </a>
        <p>
          All user data will be deleted: username, password, any uploaded images, all custom language data and progress.
          Data will be deleted within one month of the request being sent.
        </p>
      </div>
        
        </div>
    );
  };

export default LsPrivacyPolicy;
